import { Linkedin } from "lucide-react";
import { Reveal, SectionHead } from "../motion";
import { LINKEDIN_URL, QUALIFICATIONS, WHY_POINTS } from "../../content";

export function About() {
  return (
    <section id="about" data-testid="about-section" className="border-y border-ink/10 bg-warmwhite">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8 sm:py-20 lg:py-24">
        <div className="grid items-start gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          <Reveal>
            <div className="relative mx-auto max-w-xs sm:max-w-sm lg:mx-0">
              <div className="absolute -bottom-4 -left-4 h-full w-full rounded-sm border border-gold" aria-hidden="true" />
              <div className="relative overflow-hidden rounded-sm">
                <img
                  src="/assets/anjali-portrait.png"
                  alt="Portrait of Anjali S. Menon"
                  data-testid="about-portrait"
                  className="aspect-[11/13] w-full object-cover"
                  loading="lazy"
                />
              </div>
              <p className="mt-5 text-center font-display text-sm italic text-ink/60 lg:text-left">
                Anjali S. Menon, AML &amp; Regulatory Compliance Consultant
              </p>
            </div>
          </Reveal>

          <div>
            <SectionHead eyebrow="About" title="About Anjali" />
            <Reveal delay={0.1}>
              <div className="mt-5 space-y-4 text-base leading-relaxed text-ink/70">
                <p>
                  I&rsquo;m Anjali Menon, an independent AML and regulatory compliance consultant with 11 years of
                  experience across the UK, UAE and Australia.
                </p>
                <p>
                  My background includes financial crime compliance, regulatory risk, governance and commercial
                  matters.
                </p>
                <p>
                  I&rsquo;ve worked with businesses on developing compliance frameworks, reviewing policies and
                  procedures, managing regulatory requirements and improving internal controls.
                </p>
                <p>
                  My experience also includes commercial contracts and in-house legal operations. I&rsquo;ve worked on
                  drafting and reviewing agreements, supporting business teams with contractual matters and managing
                  legal and compliance requirements across different jurisdictions.
                </p>
                <p>
                  I take a practical approach to compliance. My focus is on understanding how a business operates,
                  identifying areas that need attention and recommending improvements that are proportionate and
                  workable.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.15}>
              <p className="mt-7 text-xs font-medium uppercase tracking-[0.24em] text-cherry">Qualifications</p>
              <ul className="mt-3 space-y-2" data-testid="about-qualifications">
                {QUALIFICATIONS.map((q) => (
                  <li key={q} className="flex items-start gap-3 text-sm text-ink/75">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" aria-hidden="true" />
                    {q}
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={0.2}>
              <p className="mt-7 text-xs font-medium uppercase tracking-[0.24em] text-cherry">Why work with me</p>
              <ul className="mt-3 space-y-2" data-testid="about-why-points">
                {WHY_POINTS.map((point) => (
                  <li key={point} className="flex items-start gap-3 text-sm text-ink/75">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" aria-hidden="true" />
                    {point}
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={0.25}>
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-linkedin-link"
                className="mt-8 inline-flex items-center gap-2 rounded-full border border-ink/25 px-6 py-2.5 text-sm font-medium text-ink transition-colors duration-200 hover:border-cherry hover:text-cherry"
              >
                <Linkedin className="h-4 w-4" aria-hidden="true" />
                View LinkedIn profile
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
